import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { ConnectedRouter } from 'connected-react-router';

import { history } from 'store';
import HelmetedRoute from 'components/HelmetedRoute';
import Home from 'pages/Home';
import SignInPage from 'pages/SignInPage';
import SignUpPage from 'pages/SignUpPage';
import SignOut from 'containers/SignOut';
import ResetPassword from 'containers/ResetPassword';
import Error from 'pages/Error';

const PrimaryLayout = () => (
  <Switch>
    <Route path="/" exact component={Home} />
    <HelmetedRoute
      path="/signin"
      component={SignInPage}
      helmetProps={{ title: 'BitTitan - Sign In' }}
    />
    <HelmetedRoute
      path="/signup"
      component={SignUpPage}
      helmetProps={{ title: 'BitTitan - Register' }}
    />
    <Route path="/signout" component={SignOut} />
    <HelmetedRoute
      path="/resetpassword"
      component={ResetPassword}
      helmetProps={{ title: 'BitTitan - Reset Password' }}
    />
    <HelmetedRoute component={Error} helmetProps={{ title: '404' }} />
  </Switch>
);

const AppLayout: React.FC = () => (
  <ConnectedRouter history={history}>
    <PrimaryLayout />
  </ConnectedRouter>
);

export default AppLayout;
